class StickyObservable extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }

  constructor() {
    super();

    this.stickyContainer = this.querySelector('.vbb-product__sticky');
    this.detailsVariants = this.querySelectorAll('.vbb-variant-selector__container')[0];

    // const handleIntersection = (entries) => {
    //   entries.forEach(({isIntersecting}) => this.update(isIntersecting));
    // };

    // new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 100px 0px'}).observe(this);
  }

  // connectedCallback() {
  //   // this.resizeBox(this.offsetHeight);
  // }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open' && oldValue !== newValue) {
      this.update(this.isIntersecting);
    }
  }

  // resizeBox(size) {
  //   this.style.height = `${size}px`;
  // }

  update(inView) {
    this.isIntersecting = inView;

    if (inView) {
      this.stickyContainer.classList.remove('active');

      if (!this.detailsVariants.hasAttribute('open')) {
        this.detailsVariants.setAttribute('open', '');
      }
    } else {
      if(this.detailsVariants){
        this.stickyContainer.classList.add('active');
        this.detailsVariants.removeAttribute('open');
      }
    }
  }
}

customElements.define('sticky-observable', StickyObservable);
